// Swaps a "next event" line's fallback text for the last given weekday of the month,
// in Pacific time. Without JavaScript the server-rendered fallback stays visible.
const TIME_ZONE = 'America/Los_Angeles';

function pacificToday() {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: TIME_ZONE, year: 'numeric', month: 'numeric', day: 'numeric',
  }).formatToParts(new Date());
  const get = (type) => Number(parts.find((p) => p.type === type).value);
  return { year: get('year'), month: get('month') - 1, day: get('day') };
}

// Calendar dates are built in UTC so the weekday never shifts with the visitor's zone.
function lastWeekdayOfMonth(year, month, weekday) {
  const date = new Date(Date.UTC(year, month + 1, 0));
  date.setUTCDate(date.getUTCDate() - ((date.getUTCDay() - weekday + 7) % 7));
  return date;
}

class SNextEvent extends HTMLElement {
  connectedCallback() {
    const target = this.querySelector('[data-next-event-text]');
    const template = this.dataset.template;
    const weekday = Number(this.dataset.weekday);
    if (!target || !template || !Number.isInteger(weekday) || weekday < 0 || weekday > 6) return;

    try {
      const today = pacificToday();
      let next = lastWeekdayOfMonth(today.year, today.month, weekday);
      if (next.getUTCDate() < today.day) next = lastWeekdayOfMonth(today.year, today.month + 1, weekday);

      const isToday = next.getUTCFullYear() === today.year && next.getUTCMonth() === today.month && next.getUTCDate() === today.day;
      const label = isToday
        ? this.dataset.today || 'Today'
        : new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
            timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric',
          }).format(next);
      if (label) target.textContent = template.replace('[date]', label);
    } catch {
      // Keep the fallback text if date formatting is unavailable.
    }
  }
}

if (!customElements.get('s-next-event')) customElements.define('s-next-event', SNextEvent);
